export const results = [
  {
    category: "app",
    resultId: 1,
    result: "Warm Spiced Olives",
    url: "https://www.epicurious.com/recipes/food/views/warmed-spiced-olives",
    imgURL:
      "https://assets.epicurious.com/photos/5f99a923dda393d6f500ffa5/1:1/pass/DoAble_Olives_RECIPE_101920_1017_VOG_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 2,
    result: "Crudites With Chile-Lime Salt",
    url: "https://www.epicurious.com/recipes/food/views/crudites-with-chile-lime-salt",
    imgURL:
      "https://assets.epicurious.com/photos/5db86a9ad2550200094ca922/1:1/pass/Crudite_RECIPE_102419_5051.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 3,
    result: "Pickled Shrimp",
    url: "https://www.epicurious.com/recipes/food/views/pickled-shrimp-12704",
    imgURL:
      "https://assets.epicurious.com/photos/5a26f942a231693d44ad8f54/1:1/pass/Pickled-Shrimp-new-years-28112017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 4,
    result: "Smoky Carrot Dip",
    url: "https://www.epicurious.com/recipes/food/views/smoky-carrot-dip",
    imgURL:
      "https://assets.epicurious.com/photos/5f9b17290c1b5e2f46e00034/1:1/pass/1019-OCH-Smoky-Carrot-Dip_VOG_test.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 5,
    result: "Tonatto Deviled Eggs",
    url: "https://www.epicurious.com/recipes/food/views/tonatto-eggs",
    imgURL:
      "https://assets.epicurious.com/photos/5de5747059ab0800097d5f10/1:1/pass/TonnatoEggs_RECIPE_112019_17268.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 6,
    result: "Butternut Squash and Apple Soup",
    url: "https://www.epicurious.com/recipes/food/views/butternut-squash-apple-soup-365210",
    imgURL:
      "https://assets.epicurious.com/photos/5c5a01d994580c2d4b9d4b11/1:1/pass/Butternut-Squash-&-Apple-Soup-31012019.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 7,
    result: "Cauliflower-Cashew Soup With Crispy Buckwheat",
    url: "https://www.epicurious.com/recipes/food/views/cauliflower-cashew-soup-with-crispy-buckwheat-51263890",
    imgURL:
      "https://assets.epicurious.com/photos/5509b640b4f519dd5804a1df/1:1/pass/51263890_cauliflower-cashew-soup_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 128,
    result: "Marinated Manchego",
    url: "https://www.epicurious.com/recipes/food/views/marinated-manchego",
    imgURL:
      "https://assets.epicurious.com/photos/5c1149613baf10424e13d8ee/1:1/pass/marinated-manchego-cheese-recipe-BA-121218.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 129,
    result: "Cacio e Pepe Chips",
    url: "https://www.epicurious.com/recipes/food/views/cacio-e-pepe-chips",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7a831bd0b471cece700/1:1/pass/cacio-e-pepe-chips-BA-111616.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 130,
    result: "Crunchy Stuffed Cremini Mushrooms",
    url: "https://www.epicurious.com/recipes/food/views/crunchy-stuffed-cremini-mushrooms",
    imgURL:
      "https://assets.epicurious.com/photos/59f9f85b933c1109fb2c60bc/1:1/pass/crunchy-stuffed-cremini-mushrooms-recipe-HC-103017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 131,
    result:
      "Roasted Carrot and Fennel Soup With Miso-Glazed Mushrooms and Cashew Cream",
    url: "https://www.epicurious.com/recipes/food/views/roasted-carrot-fennel-soup-miso-mushrooms-cashew-cream",
    imgURL:
      "https://assets.epicurious.com/photos/603eb30d0382627eaf9f566e/1:1/pass/CarrotGingerSoup_RECIPE_022621_088.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 132,
    result: "Panisses With Sage Leaves and Lemon",
    url: "https://www.epicurious.com/recipes/food/views/panisses-with-sage-leaves-and-lemon",
    imgURL:
      "https://assets.epicurious.com/photos/58c6be275eadb2183663cba4/1:1/pass/panisses-with-sage-and-lemon-BA-031317.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 133,
    result: "Roasted Sweet Potato and Ginger Soup",
    url: "https://www.epicurious.com/recipes/food/views/roasted-sweet-potato-and-ginger-soup",
    imgURL:
      "https://assets.epicurious.com/photos/59fa3d48837b1201f3d09d84/1:1/pass/roasted-sweet-potato-ginger-soup-recipe-HC-103017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "app",
    resultId: 134,
    result: "Butternut Squash Tarte Tatin",
    url: "https://www.epicurious.com/recipes/food/views/butternut-squash-tarte-tatin",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fbb531ddb2da6158752/1:1/pass/butternut-squash-tarte-tatin-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 8,
    result: "Fifty-Fifty Martini",
    url: "https://www.epicurious.com/recipes/food/views/fifty-fifty-237575",
    imgURL:
      "https://assets.epicurious.com/photos/5defc7d0ce61b9000896d0c6/1:1/pass/5050Martini_RECIPE_120519_13934.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 9,
    result: "Lipstick Memory",
    url: "https://www.epicurious.com/recipes/food/views/lipstick-memory-cranberry-campari-cocktail",
    imgURL:
      "https://assets.epicurious.com/photos/5fa47f2336cf430a9b7e594c/1:1/pass/LipstickMemory_HERO_110420_4493.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 10,
    result: "French 75",
    url: "https://www.epicurious.com/recipes/food/views/french-75-242668",
    imgURL:
      "https://assets.epicurious.com/photos/6123d145663e652dbef9886e/1:1/pass/French75_RECIPE_082021_20487.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 11,
    result: "Paradise Apple",
    url: "https://www.epicurious.com/recipes/food/views/paradise-apple-thanksgiving-cocktail-bourbon-cider",
    imgURL:
      "https://assets.epicurious.com/photos/5fa480758c21eda8cdfd16c8/1:1/pass/ParadiseApple_HERO_RECIPE_110420_4447.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 12,
    result: "Padova Spritz",
    url: "https://www.epicurious.com/recipes/food/views/nonalcoholic-padova-spritz-julia-bainbridge",
    imgURL:
      "https://assets.epicurious.com/photos/5fb3f81ce9bd6fb2e3065124/1:1/pass/PadovaSpritz_HERO_111220_5313.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 13,
    result: "Perfect Circle",
    url: "https://www.epicurious.com/recipes/food/views/perfect-circle-champagne-sherry-campari-cocktail",
    imgURL:
      "https://assets.epicurious.com/photos/5bc61c665a41832ce222985b/1:1/pass/Batch-Cocktails_Perfect-Circle.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 14,
    result: "Scotchy Boulevardiers",
    url: "https://www.epicurious.com/recipes/food/views/scotchy-boulevardiers-for-a-crowd",
    imgURL:
      "https://assets.epicurious.com/photos/5dc5d59d2d77fc000918287c/1:1/pass/ScotchBoulevardier_HERO_103019_5723.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 15,
    result: "Champagne Punch With Brandy and Citrus",
    url: "https://www.epicurious.com/recipes/food/views/champagne-punch-241174",
    imgURL:
      "https://assets.epicurious.com/photos/5c93d13f1a650a3ccce8f78a/1:1/pass/Champagne-Punch-recipe-1-18032019.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 16,
    result: "Thanksgiving Sangria",
    url: "https://www.epicurious.com/recipes/food/views/thanksgiving-sangria",
    imgURL:
      "https://assets.epicurious.com/photos/59bc35110222e72ca71d840d/1:1/pass/Say-Hello-to-Thanksgiving-Sangria-recipe-12092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 170,
    result: "Ginger and Tamarind Refresher",
    url: "https://www.epicurious.com/recipes/food/views/ginger-and-tamarind-refresher-nik-sharma",
    imgURL:
      "https://assets.epicurious.com/photos/5f3170c67b7a251be6a48635/1:1/w_2240,c_limit/GingerTamarindRefresher_RECIPE_080520_10454_VOG_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 171,
    result: "Cherry and Smoke Nonalcoholic Cocktail",
    url: "https://www.epicurious.com/recipes/food/views/cherry-and-smoke-nonalcoholic-cocktail",
    imgURL:
      "https://assets.epicurious.com/photos/5fb3f9310eed25b41291d447/1:1/w_2240,c_limit/CherrySmoke_HERO_111220_5284.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "drinks",
    resultId: 172,
    result: "Inside-Out Iced Tea",
    url: "https://www.epicurious.com/recipes/food/views/inside-out-iced-tea-hibiscus-ice-cubes-summer",
    imgURL:
      "https://assets.epicurious.com/photos/61142304d4c904e186a003f9/1:1/w_1600,c_limit/HibiscusIcedTea_HERO_080521_19767.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 17,
    // result: "My Favorite Roast Turkey + Why-Is-It-So-Good Gravy",
    result1: "My Favorite Roast Turkey",
    result2: "Why-Is-It-So-Good Gravy",
    url: "https://www.epicurious.com/recipes/food/views/my-favorite-roast-turkey-51258050",
    imgURL:
      "https://assets.epicurious.com/photos/5f99a93bba8cbd3ce5c1a8b5/1:1/pass/TKTurkey_RECIPE_101920_1233_VOG_final.jpg",
    url2: "https://www.epicurious.com/recipes/food/views/why-is-it-so-good-gravy",
    imgURL2:
      "https://assets.epicurious.com/photos/5dd306f9ede8290009cece37/1:1/w_1600,c_limit/Why_is_it_so_good_gravy_recipe_BA_111818.jpg",
    url3: null,
    imgURL3: null,
    noOfDishes: 2,
  },
  {
    category: "mains",
    resultId: 18,
    result: "My Favorite Roast Turkey + Gluten Free Gravy",
    result1: "My Favorite Roast Turkey",
    result2: "Gluten Free Gravy",
    url: "https://www.epicurious.com/recipes/food/views/my-favorite-roast-turkey-51258050",
    imgURL:
      "https://assets.epicurious.com/photos/5f99a93bba8cbd3ce5c1a8b5/1:1/pass/TKTurkey_RECIPE_101920_1233_VOG_final.jpg",
    url2: "https://www.epicurious.com/recipes/food/views/gluten-free-turkey-gravy",
    imgURL2:
      "https://assets.epicurious.com/photos/616590b069d75e52172b4325/1:1/w_2240,c_limit/GlutenFreeGravy_RECIPE_100621_408.jpg",
    url3: null,
    imgURL3: null,
    noOfDishes: 2,
  },
  {
    category: "mains",
    resultId: 19,
    result: "The Simplest Roast Turkey + Why-Is-It-So-Good Gravy",
    result1: "The Simplest Roast Turkey",
    result2: "Why-Is-It-So-Good Gravy",
    url: "https://www.epicurious.com/recipes/food/views/the-simplest-roast-turkey-232985",
    imgURL:
      "https://assets.epicurious.com/photos/5bb392eee136ae34fb63adc3/1:1/w_1600,c_limit/The-Simplest-Roast-Turkey-14092018.jpg",
    url2: "https://www.epicurious.com/recipes/food/views/why-is-it-so-good-gravy",
    imgURL2:
      "https://assets.epicurious.com/photos/5dd306f9ede8290009cece37/1:1/w_1600,c_limit/Why_is_it_so_good_gravy_recipe_BA_111818.jpg",
    url3: null,
    imgURL3: null,
    noOfDishes: 2,
  },
  {
    category: "mains",
    resultId: 20,
    result: "The Simplest Roast Turkey + Gluten Free Gravy",
    result1: "The Simplest Roast Turkey",
    result2: "Gluten Free Gravy",
    url: "https://www.epicurious.com/recipes/food/views/the-simplest-roast-turkey-232985",
    imgURL:
      "https://assets.epicurious.com/photos/5bb392eee136ae34fb63adc3/1:1/w_1600,c_limit/The-Simplest-Roast-Turkey-14092018.jpg",
    url2: "https://www.epicurious.com/recipes/food/views/gluten-free-turkey-gravy",
    imgURL2:
      "https://assets.epicurious.com/photos/616590b069d75e52172b4325/1:1/w_2240,c_limit/GlutenFreeGravy_RECIPE_100621_408.jpg",
    url3: null,
    imgURL3: null,
    noOfDishes: 2,
  },
  {
    category: "mains",
    resultId: 21,
    result: "Miso-Butter Roast Chicken With Acorn Squash Panzanella",
    url: "https://www.epicurious.com/recipes/food/views/miso-butter-roast-chicken-acorn-squash-panzanella",
    imgURL:
      "https://assets.epicurious.com/photos/5f99a91e819b886aba0a2846/1:1/pass/Chickensgiving_HERO_RECIPE_101920_1374_VOG_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 22,
    result: "Confit Turkey With Chiles and Garlic",
    url: "https://www.epicurious.com/recipes/food/views/confit-turkey-with-chiles-and-garlic",
    imgURL:
      "https://assets.epicurious.com/photos/5fada51432c8439e2ac9ce8c/1:1/pass/TurkeyConfit_RECIPE_101920_1312_V1_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 23,
    result: "Turkey for Two With Pan Sauce Gravy",
    url: "https://www.epicurious.com/recipes/food/views/turkey-for-two-with-pan-sauce-gravy",
    imgURL:
      "https://assets.epicurious.com/photos/5bce520e489f5413ee1e0027/1:1/pass/Thanksgiving-2-4-Turkey-for-two-recipe-09102018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 24,
    result: "Pastrami Turkey Breast",
    url: "https://www.epicurious.com/recipes/food/views/pastrami-turkey-breast-best-turkey-sandwiches",
    imgURL:
      "https://assets.epicurious.com/photos/616d8abbfe560954239d5393/1:1/pass/PastramiTurkeySandwich_RECIPE_100621_567.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 25,
    result: "Fried Turkey Wings",
    url: "https://www.epicurious.com/recipes/food/views/fried-turkey-wings-with-cranberry-glaze",
    imgURL:
      "https://assets.epicurious.com/photos/61658e6f12d06f85b9ed81bc/1:1/pass/FriedTurkeyWings_RECIPE_100621_317.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 26,
    result: "Stuffed Squash With Preserved Lemon Gravy",
    url: "https://www.epicurious.com/recipes/food/views/stuffed-squash-with-preserved-lemon-gravy",
    imgURL:
      "https://assets.epicurious.com/photos/616dcf90c1d02bedcba455ad/1:1/pass/StuffedSquashPreservedLemonGravy_RECIPE_100621_222.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 27,
    result: "Braised Butternut Squash in Spiced Coconut Gravy",
    url: "https://www.epicurious.com/recipes/food/views/braised-butternut-squash-in-spiced-coconut-gravy",
    imgURL:
      "https://assets.epicurious.com/photos/616dccca825bee3447936d9c/1:1/pass/BraisedButternutCoconut_RECIPE_101421_256.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 28,
    result: "Butternut Squash Vegducken",
    url: "https://www.epicurious.com/recipes/food/views/butternut-squash-vegducken-with-mushroom-cranberry-stuffing-recipe",
    imgURL:
      "https://assets.epicurious.com/photos/581b4dcef345b0f8069c979a/1:1/pass/vegducken-2.0-hero-11012016.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 29,
    result: "Kale and Wild Rice Stuffed Winter Squash",
    url: "https://www.epicurious.com/recipes/food/views/kale-and-wild-rice-stuffed-winter-squash",
    imgURL:
      "https://assets.epicurious.com/photos/5a7365aeeda815789dd3d003/1:1/pass/kale-and-wild-rice-stuffed-acorn-squash-recipe-HC-020118.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 30,
    result:
      "My Favorite Roast Turkey + Gluten Free Gravy + Kale & Wild Rice Stuffed Winter Squash",
    result1: "My Favorite Roast Turkey",
    result2: "Gluten Free Gravy",
    result3: "Kale & Wild Rice Stuffed Winter Squash",
    url: "https://www.epicurious.com/recipes/food/views/my-favorite-roast-turkey-51258050",
    imgURL:
      "https://assets.epicurious.com/photos/5f99a93bba8cbd3ce5c1a8b5/1:1/pass/TKTurkey_RECIPE_101920_1233_VOG_final.jpg",
    url2: "https://www.epicurious.com/recipes/food/views/gluten-free-turkey-gravy",
    imgURL2:
      "https://assets.epicurious.com/photos/616590b069d75e52172b4325/1:1/w_2240,c_limit/GlutenFreeGravy_RECIPE_100621_408.jpg",
    url3: "https://www.epicurious.com/recipes/food/views/kale-and-wild-rice-stuffed-winter-squash",
    imgURL3:
      "https://assets.epicurious.com/photos/5a7365aeeda815789dd3d003/1:1/pass/kale-and-wild-rice-stuffed-acorn-squash-recipe-HC-020118.jpg",
    noOfDishes: 3,
  },
  {
    category: "mains",
    resultId: 135,
    result: "Citrus Sage Roast Turkey Breast With Gravy",
    url: "https://www.epicurious.com/recipes/food/views/citrus-sage-roast-turkey-breast-with-gravy-small-crowd-51137810",
    imgURL:
      "https://assets.epicurious.com/photos/560aa3226a59cdb91b60182a/1:1/pass/51137810_turkey-breast.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 136,
    result: "Stock Braised Turkey Legs",
    url: "https://www.epicurious.com/recipes/food/views/stock-braised-turkey-legs",
    imgURL:
      "https://assets.epicurious.com/photos/5a05db0b1a9e232c87581a7d/1:1/pass/stock-braised-turkey-legs-recipe-BA-111017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 137,
    result: "Roasted Turkey Legs With Ghee",
    url: "https://www.epicurious.com/recipes/food/views/roasted-turkey-legs-with-ghee",
    imgURL:
      "https://assets.epicurious.com/photos/5b981c636d0c5b482edfe4f5/1:1/pass/Roasted-Turkey-Legs-with-Ghee-recipe-05092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 138,
    result: "Brined and Barbecued Turkey",
    url: "https://www.epicurious.com/recipes/food/views/brined-and-barbecued-turkey-240484",
    imgURL:
      "https://assets.epicurious.com/photos/5b9813048127422e2d2f45c9/1:1/pass/Brined-and-Barbecued-Turkey-05092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 139,
    result: "Quick Thanksgiving Turkey With Lemon Garlic Butter",
    url: "https://www.epicurious.com/recipes/food/views/quick-thanksgiving-turkey-with-lemon-garlic-butter",
    imgURL:
      "https://assets.epicurious.com/photos/61646c749ddfac5a62f08564/1:1/pass/Quick-Thanksgiving-Turkey-RECIPE-10102017.jpeg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 140,
    result: "Smoky Dry Rubbed Pork Steaks",
    url: "https://www.epicurious.com/recipes/food/views/smoky-dry-rubbed-pork-steaks",
    imgURL:
      "https://assets.epicurious.com/photos/5db85c2e8c5e0a0008d23783/1:1/pass/Pork_HERO_102419_4939.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 141,
    result: "Duck Breast With Sweet Cherry Sauce",
    url: "https://www.epicurious.com/recipes/food/views/duck-breast-with-sweet-cherry-sauce-232306",
    imgURL:
      "https://assets.epicurious.com/photos/5c3762496ba29430dab346ed/1:1/pass/duck-breast-with-cherry-sauce-recipe-gourmet-010919.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 142,
    result: "Duck Two Ways With Clementine-Fig Relish",
    url: "https://www.epicurious.com/recipes/food/views/duck-two-ways-with-clementine-fig-relish",
    imgURL:
      "https://assets.epicurious.com/photos/58486c9ebbf20a4f3a3e5604/1:1/pass/duck-two-ways-with-clementine-fig-relish-120716.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 143,
    result: "Crisp Roast Duck",
    url: "https://www.epicurious.com/recipes/food/views/crisp-roast-duck-235744",
    imgURL:
      "https://assets.epicurious.com/photos/5c93f15d7903444d883ded50/1:1/pass/Crisp-Roast-Duck-19032019.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 144,
    result: "Roast Goose With Oranges and Madeira",
    url: "https://www.epicurious.com/recipes/food/views/roast-goose-with-oranges-and-madeira-966",
    imgURL:
      "https://assets.epicurious.com/photos/5a27131749f7c631c109e234/1:1/pass/Roast-Goose-with-Oranges-and-Madeira-28112017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 145,
    result: "Braised Chile-Marmalade Duck Legs",
    url: "https://www.epicurious.com/recipes/food/views/braised-chile-marmalade-duck-legs-brussels-sprouts",
    imgURL:
      "https://assets.epicurious.com/photos/5fd79677b9c5bc2b1f6c8c99/1:1/pass/MarmaladeDuck_HERO_121020_6412.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 146,
    result: "Cold Roast Salmon With Smashed Green Bean Salad",
    url: "https://www.epicurious.com/recipes/food/views/cold-roast-salmon-with-smashed-green-bean-salad",
    imgURL:
      "https://assets.epicurious.com/photos/5b61e374f769c40c0ee16120/1:1/pass/cold-roast-salmon-with-smashed-green-bean-salad-recipe-BA-080118.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 147,
    result: "Garlic Aioli Roasted Turkey With Lemon Parsley Pan Sauce",
    url: "https://www.epicurious.com/recipes/food/views/garlic-aioli-roasted-turkey-with-lemon-parsley-au-jus",
    imgURL:
      "https://assets.epicurious.com/photos/5db86b27d2550200094ca924/1:1/pass/Turkey_RECIPE_102419_4997.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 148,
    result: "Mushroom Adobo",
    url: "https://www.epicurious.com/recipes/food/views/mushroom-adobo",
    imgURL:
      "https://assets.epicurious.com/photos/610048aa77a5de8d49575bb2/1:1/pass/AdoboMushrooms_RECIPE_072221_19426.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 149,
    result: "Creamy Vegan Mushroom Lasagna",
    url: "https://www.epicurious.com/recipes/food/views/creamy-mushroom-lasagna",
    imgURL:
      "https://assets.epicurious.com/photos/585c0118661915cd34f0eb0b/1:1/pass/mushroom-lasagna-HC-122116.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 150,
    result: "Oven Polenta With Roast Mushrooms and Thyme",
    url: "https://www.epicurious.com/recipes/food/views/oven-polenta-with-roasted-mushrooms-and-thyme",
    imgURL:
      "https://assets.epicurious.com/photos/5bc4da29cf10732db9a8c441/1:1/pass/oven-polenta-with-roasted-mushrooms-and-thyme-recipe-BA-101518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 151,
    result: "Torta Pasqualina",
    url: "https://www.epicurious.com/recipes/food/views/torta-pasqualina",
    imgURL:
      "https://assets.epicurious.com/photos/5ad78630f1bfb636b660d2ad/1:1/pass/torta-pasqualina-recipe-BA-041818.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 152,
    result: "Gravy Braised Turkey Legs With Cipolline Onions",
    url: "https://www.epicurious.com/recipes/food/views/gravy-braised-turkey-legs-with-cipolline-onions",
    imgURL:
      "https://assets.epicurious.com/photos/563a1b6c79b674000c8b0860/1:1/pass/gravy-braised-turkey-legs-cipolline-onions.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 153,
    result: "Squash Au Vin",
    url: "https://www.epicurious.com/recipes/food/views/squash-au-vin",
    imgURL:
      "https://assets.epicurious.com/photos/5e6bbec208779c000830308a/1:1/pass/squash-au-vin-recipe-BA-031020.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "mains",
    resultId: 178,
    result: "Cauliflower Steaks With Coconut-Turmeric Relish",
    url: "https://www.epicurious.com/recipes/food/views/cauliflower-steaks-with-coconut-turmeric-relish",
    imgURL:
      "https://assets.epicurious.com/photos/5ac271db7243eb5a46ae46e6/1:1/w_1920,c_limit/cauliflower-steaks-recipe-BA-032918.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 31,
    result: "Italian Sausage and Bread Stuffing",
    url: "https://www.epicurious.com/recipes/food/views/italian-sausage-and-bread-stuffing-240559",
    imgURL:
      "https://assets.epicurious.com/photos/5bb39022e136ae34fb63adc1/1:1/pass/Italian-Sausage-and-Bread-Stuffing-14092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 32,
    result: "Wild Rice Dressing",
    url: "https://www.epicurious.com/recipes/food/views/wild-rice-dressing",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fc55261fb2d904669b9/1:1/pass/wild-rice-dressing-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 33,
    result: "Skillet Dressing With Cornbread and Biscuits",
    url: "https://www.epicurious.com/recipes/food/views/skillet-dressing-with-cornbread-and-biscuits",
    imgURL:
      "https://assets.epicurious.com/photos/5be083bf531ddb2da6158754/1:1/pass/cornbread-biscuit-stuffing-23102018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 34,
    result: "Sticky Rice Stuffing With Chinese Sausage and Shiitakes",
    url: "https://www.epicurious.com/recipes/food/views/sticky-rice-stuffing-with-chinese-sausage-and-shiitakes-51252600",
    imgURL:
      "https://assets.epicurious.com/photos/555a1487644d45515b755f72/1:1/pass/51252600_sticky-rice-stuffing_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 35,
    result: "Baguette, Smoked Oyster, and Pancetta Stuffing",
    url: "https://www.epicurious.com/recipes/food/views/baguette-smoked-oyster-and-pancetta-stuffing-51255130",
    imgURL:
      "https://assets.epicurious.com/photos/54aaf9386529d92b2c03063a/1:1/pass/51255130_baguette-oyster-stuffing-_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 36,
    result: "Spicy Cornbread Stuffing With Chorizo and Sweet Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/spicy-cornbread-stuffing-with-chorizo-and-sweet-potatoes",
    imgURL:
      "https://assets.epicurious.com/photos/5bd36156168d1937716070e0/1:1/pass/Large-Format-Savory-Sweet-Potato-Cornbread-Stuffing-11102018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 37,
    result: "If It Ain't Broke, Don't Fix It Stuffing",
    url: "https://www.epicurious.com/recipes/food/views/if-it-aint-broke-dont-fix-it-stuffing",
    imgURL:
      "https://assets.epicurious.com/photos/5a05db0bf819553e017bd988/1:1/pass/if-it-aint-broke-dont-fix-it-stuffing-recipe-BA-111017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 38,
    result: "Savory Herb Bread Pudding",
    url: "https://www.epicurious.com/recipes/food/views/savory-herb-bread-pudding",
    imgURL:
      "https://assets.epicurious.com/photos/616461dbf8262d9aaba80f20/1:1/pass/VeganStuffing_RECIPE_100621_350.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 39,
    result: "Simple Is Best Dressing",
    url: "https://www.epicurious.com/recipes/food/views/simple-is-best-dressing-51124210",
    imgURL:
      "https://assets.epicurious.com/photos/59bc186dbf70cb1b35bc3e22/1:1/pass/SIMPLE-IS-BEST-DRESSING-RECIPE-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "stuffing",
    resultId: 173,
    result: "Cornbread, Sausage, and Pecan Dressing",
    url: "https://www.epicurious.com/recipes/food/views/cornbread-sausage-and-pecan-dressing-51124200",
    imgURL:
      "https://assets.epicurious.com/photos/54b05d6afca98987608b14d0/1:1/w_1600,c_limit/51124200_cornbread-sausage-pecan-dressing_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 40,
    result: "Our Favorite Creamy Mashed Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/our-favorite-creamy-mashed-potatoes",
    imgURL:
      "https://assets.epicurious.com/photos/5820b76b32d6607c5d3dd740/1:1/pass/Our-Favorite-creamy-Mashed-Potatoes-04112016.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 41,
    result: "Creamy Potato and Leek Gratin",
    url: "https://www.epicurious.com/recipes/food/views/creamy-potato-and-leek-gratin",
    imgURL:
      "https://assets.epicurious.com/photos/5c09992d0899e22c8f5b4990/1:1/pass/Gourmet-Christmas-Creamy-Potato-and-leek-Gratin-Recipe-13112018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 42,
    result: "Make-Ahead Mashed Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/make-ahead-mashed-potatoes",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fc09d2c4c2d684d74ec/1:1/pass/make-ahead-mashed-potatoes-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 43,
    result: "Forked Oven-Roasted Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/forked-oven-roasted-potatoes-368937",
    imgURL:
      "https://assets.epicurious.com/photos/5fb3e0ccc270d84462b38404/1:1/pass/1211-BA-WPOT-06_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 44,
    result: "Crispy Baby Yukon Gold Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/crispy-baby-yukon-gold-potatoes",
    imgURL:
      "https://assets.epicurious.com/photos/582f63cf971f420e380c22f4/1:1/pass/Crispy-Baby-yukon-Gold-Potatoes--17112016.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 45,
    result: "Torn Potatoes of Many Colors With Chile-Lime Butter",
    url: "https://www.epicurious.com/recipes/food/views/torn-potatoes-of-many-colors-with-chile-lime-butter",
    imgURL:
      "https://assets.epicurious.com/photos/5db9fbd3ef70180008e72679/1:1/pass/TornPotatoes_RECIPE_102319_4521.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 46,
    result: "Duchess Baked Potatoes",
    url: "https://www.epicurious.com/recipes/food/views/duchess-baked-potatoes",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7aa971f420e380c22ca/1:1/pass/duchess-baked-potatoes-BA-111616.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 47,
    result: "Cheesy Potato and Kale Gratin With Rye Croutons",
    url: "https://www.epicurious.com/recipes/food/views/cheesy-potato-and-kale-gratin-with-rye-croutons",
    imgURL:
      "https://assets.epicurious.com/photos/59c032aa0e38ae1a0e29ea3e/1:1/pass/Potato-Kale-Gratin-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "potatoes",
    resultId: 167,
    result: "skip",
    url: "",
    imgURL: "#N/A",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 48,
    result: "Roasted Sweet Potato and Delicata Squash With Cranberry Agrodolce",
    url: "https://www.epicurious.com/recipes/food/views/roasted-sweet-potato-and-delicata-squash-with-cranberry-agrodolce",
    imgURL:
      "https://assets.epicurious.com/photos/5f9b21aaac233d4a1eb94582/1:1/pass/Roasted-Sweet-Potato-and-Squash-Rounds-with-Cranberry-Agrodolce-10102017_V1_test.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 49,
    result: "3-Ingredient Sweet Potato Casserole With Maple Pecans",
    url: "https://www.epicurious.com/recipes/food/views/3-ingredient-sweet-potato-casserole-with-maple-pecans",
    imgURL:
      "https://assets.epicurious.com/photos/5f9b1f440c1b5e2f46e00037/1:1/pass/3-ingredient-thanksgiving-sweet-Potato-Casserole-With-Maple-Pecans-01092016_V1_test.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 50,
    result: "Spiced Sweet Potato and Parsnip Tian",
    url: "https://www.epicurious.com/recipes/food/views/spiced-sweet-potato-and-parsnip-tian",
    imgURL:
      "https://assets.epicurious.com/photos/562fd9f3dfc2c10962dd972d/1:1/pass/EP_10132015_Thnksgvng_Menu_354.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 51,
    result: "Sweet Potatoes With Orange Bitters",
    url: "https://www.epicurious.com/recipes/food/views/sweet-potatoes-with-orange-bitters-51254470",
    imgURL:
      "https://assets.epicurious.com/photos/54aafcc66529d92b2c030b8f/1:1/pass/51254470_sweet-potato-orange_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 52,
    result: "Shingled Sweet Potatoes With Harissa",
    url: "https://www.epicurious.com/recipes/food/views/shingled-sweet-potatoes-with-harissa",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fc4e36c35720dfec143/1:1/pass/shingled-sweet-potatoes-with-harissa-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sweet-potatoes",
    resultId: 168,
    result: "skip",
    url: "",
    imgURL: "#N/A",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 53,
    result: "Skillet Cornbread With Bacon Fat and Brown Sugar",
    url: "https://www.epicurious.com/recipes/food/views/skillet-cornbread-with-bacon-fat-and-brown-sugar",
    imgURL:
      "https://assets.epicurious.com/photos/5eea7be59d97ae4950cc7163/1:1/pass/skillet-cornbread-recipe-061720.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 54,
    result: "Skillet Cornbread With Chives",
    url: "https://www.epicurious.com/recipes/food/views/skillet-cornbread-with-chives",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7b1b3446c1b212b9d7e/1:1/pass/skillet-cornbread-with-chives-BA-111416.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 55,
    result: "Cornbread Muffins With Whipped Sweet Corn",
    url: "https://www.epicurious.com/recipes/food/views/cornbread-muffins-with-whipped-sweet-corn",
    imgURL:
      "https://assets.epicurious.com/photos/5f31712ac43a137c69ebb467/1:1/pass/VegKingdomCornBreadMuffins_RECIPE_080520_10356_VOG_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 56,
    result: "Dinner Rolls",
    url: "https://www.epicurious.com/recipes/food/views/dinner-rolls-six-ways",
    imgURL:
      "https://assets.epicurious.com/photos/5823a45330a232866c111cb8/1:1/pass/dinner-rolls-6-ways-09112016.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 57,
    result: "Lemon-Pepper Popovers",
    url: "https://www.epicurious.com/recipes/food/views/lemon-pepper-popovers-242299",
    imgURL:
      "https://assets.epicurious.com/photos/560d78607b55306961bf33b4/1:1/pass/242299_hires.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 58,
    result: "3-Ingredient Buttermilk Biscuits",
    url: "https://www.epicurious.com/recipes/food/views/3-ingredient-buttermilk-biscuits",
    imgURL:
      "https://assets.epicurious.com/photos/568fe72671b6e8d845f9248a/1:1/pass/EP_01072016_3ingredient_biscuits.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 59,
    result: "Buttermilk Biscuits With Honey Butter",
    url: "https://www.epicurious.com/recipes/food/views/buttermilk-biscuits-with-honey-butter",
    imgURL:
      "https://assets.epicurious.com/photos/566863e7dfc05f4039b5d7ad/1:1/pass/EP_12012015_dannymeyers_bluesmoke_Buttermilk-Biscuits-with-Honey-Butter.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "bread",
    resultId: 165,
    result: "skip",
    url: "",
    imgURL: "#N/A",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 60,
    result: "Roasted Brussels Sprouts With Garlic and Pancetta",
    url: "https://www.epicurious.com/recipes/food/views/roasted-brussels-sprouts-with-garlic-and-pancetta-104566",
    imgURL:
      "https://assets.epicurious.com/photos/5bb39617e136ae34fb63adc5/1:1/pass/Roasted-Brussels-Sprouts-with-Garlic-and-Pancetta-14092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 62,
    result: "Roasted Brussels Sprouts With Warm Honey Glaze",
    url: "https://www.epicurious.com/recipes/food/views/roasted-brussels-sprouts-with-warm-honey-glaze",
    imgURL:
      "https://assets.epicurious.com/photos/5c892d2c9d70b32d4dccd957/1:1/pass/roasted-honey-glazed-brussels-sprouts-recipe-BA-031319.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 63,
    result: "Stir-Fried Brussels Sprouts",
    url: "https://www.epicurious.com/recipes/food/views/stir-fried-brussels-sprouts",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fc567774e5d5ae339b4/1:1/pass/stir-fried-brussels-sprouts-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 64,
    result: "Brussels Sprouts With Pistachios and Lime",
    url: "https://www.epicurious.com/recipes/food/views/brussels-sprouts-with-pistachios-and-lime",
    imgURL:
      "https://assets.epicurious.com/photos/5dd2ee4256c4b30009ff24be/1:1/pass/Brussels_sprouts_with_pistachios_and_lime_recipe_BA_111819.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 65,
    result: "Haricots Verts With Herb Butter",
    url: "https://www.epicurious.com/recipes/food/views/haricots-verts-with-herb-butter-240576",
    imgURL:
      "https://assets.epicurious.com/photos/59bc04c6ad4eea154dba80b9/1:1/pass/HARICOTS-VERTS-WITH-HERB-BUTTER-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 66,
    result: "Green Bean and Mushroom Casserole With Crispy Fried Onions",
    url: "https://www.epicurious.com/recipes/food/views/green-bean-and-mushroom-casserole-with-crispy-fried-onions",
    imgURL:
      "https://assets.epicurious.com/photos/59c032ab1502cf6a726f0015/1:1/pass/Mushroom-Green-Bean-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 67,
    result: "3-Ingredient Lemony Green Beans With Frizzled Leeks",
    url: "https://www.epicurious.com/recipes/food/views/3-ingredient-lemony-green-beans-with-frizzled-leeks",
    imgURL:
      "https://assets.epicurious.com/photos/5f9b1e965e221e8ae0a2917d/1:1/pass/3-ingredient-thanksgiving-lemony-green-beans-with-Frizzled-Leeks-01092016_VOG_test.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 68,
    result: "Slow-Cooked Green Beans With Harissa and Cumin",
    url: "https://www.epicurious.com/recipes/food/views/slow-cooked-green-beans-with-harissa-and-cumin",
    imgURL:
      "https://assets.epicurious.com/photos/5ba00b2cfe44ba5462642049/1:1/pass/slow-cooked-green-beans-with-harissa-and-cumin-recipe-BA-091718.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 78,
    result: "Maple-Roasted Acorn Squash",
    url: "https://www.epicurious.com/recipes/food/views/maple-roasted-acorn-squash-ina-garten",
    imgURL:
      "https://assets.epicurious.com/photos/5f3acdcb6285a6f22f32068b/1:1/pass/maple roasted acorn squash.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 79,
    result: "Cheesy Baked Butternut Squash Polenta",
    url: "https://www.epicurious.com/recipes/food/views/cheesy-baked-butternut-squash-polenta",
    imgURL:
      "https://assets.epicurious.com/photos/5db724edb6ce0d0009816794/1:1/pass/Polenta_RECIPE_v1_102319_4595.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 80,
    result: "Butternut Squash Tarte Tatin",
    url: "https://www.epicurious.com/recipes/food/views/butternut-squash-tarte-tatin",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fbb531ddb2da6158752/1:1/pass/butternut-squash-tarte-tatin-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 81,
    result: "Parmesan-Roasted Butternut Squash",
    url: "https://www.epicurious.com/recipes/food/views/parmesan-roasted-butternut-squash-350608",
    imgURL:
      "https://assets.epicurious.com/photos/5bb390e3699dbf53d1b3a71a/1:1/pass/Parmesan-Roasted-Butternut-Squash-14092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 82,
    result: "Roast Pumpkin With Dukkha and Pomegranate",
    url: "https://www.epicurious.com/recipes/food/views/roast-pumpkin-with-dukkah-and-pomegranate",
    imgURL:
      "https://assets.epicurious.com/photos/5bd73fdeb559a344c9220511/1:1/pass/roasted-pumpkin-with-dukkah-and-pomegranate-recipe-HC-102918.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 83,
    result: "Butternut Squash and Creamed-Spinach Gratin",
    url: "https://www.epicurious.com/recipes/food/views/butternut-squash-and-creamed-spinach-gratin-236374",
    imgURL:
      "https://assets.epicurious.com/photos/5f9b1c602be105d7b709d0da/1:1/w_1600,c_limit/Butternut-Squash-and-Creamed-Spinach-Gratin-14092018_VOG_test.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 84,
    result: "Coconut Creamed Greens",
    url: "https://www.epicurious.com/recipes/food/views/coconut-creamed-greens",
    imgURL:
      "https://assets.epicurious.com/photos/5dd30095d482f10008d4fb27/1:1/pass/Coconut_creamed_greens_recipe_BA_111819.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 85,
    result: "Slow-Cooked Collard Greens in Olive Oil",
    url: "https://www.epicurious.com/recipes/food/views/slow-cooked-collard-greens-in-olive-oil",
    imgURL:
      "https://assets.epicurious.com/photos/5a05db0f47bc8227618ffb17/1:1/pass/slow-cooked-collard-greens-in-olive-oil-recipe-BA-111017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 86,
    result: "Wilted Chard With Shallots and Vinegar",
    url: "https://www.epicurious.com/recipes/food/views/wilted-chard-with-shallots-and-vinegar",
    imgURL:
      "https://assets.epicurious.com/photos/568eaca9f3eb5d7849ffae6d/1:1/pass/Wilted-Chard-With-Shallots.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 87,
    result: "Creamed Collard Greens",
    url: "https://www.epicurious.com/recipes/food/views/creamed-collard-greens-368257",
    imgURL:
      "https://assets.epicurious.com/photos/5682c79fa6484b0c2258cead/1:1/pass/368257_hires.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 88,
    result: "Our Favorite Macaroni and Cheese",
    url: "https://www.epicurious.com/recipes/food/views/our-favorite-macaroni-and-cheese-51255890",
    imgURL:
      "https://assets.epicurious.com/photos/573e30d2d44d8a8c0ea68d19/1:1/pass/51255890_macaroni-and-cheese_hires.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 89,
    result: "Easy Vegan Mac and Cheese",
    url: "https://www.epicurious.com/recipes/food/views/easy-vegan-mac-and-cheeze",
    imgURL:
      "https://assets.epicurious.com/photos/615743d13df38e6e5a60d631/1:1/pass/EasyVeganMacAndCheeze_RECIPE_093021_21567.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 174,
    result: "Sauteed Brussels Sprouts With Lemon and Pistachios",
    url: "https://www.epicurious.com/recipes/food/views/sauteed-brussels-sprouts-with-lemon-and-pistachios-241353",
    imgURL:
      "https://assets.epicurious.com/photos/560d9afaf3a00aeb2f1cf9ca/1:1/w_1600,c_limit/241353_hires.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 175,
    result: "Green Beans Amandine",
    url: "https://www.epicurious.com/recipes/food/views/green-beans-amandine",
    imgURL:
      "https://assets.epicurious.com/photos/5a1ed719d2044125c1513f65/1:1/w_1280,c_limit/Retro-Christmas-green-beans-amandine-21112017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 176,
    result: "Sautéed Collard Greens with Slab Bacon",
    url: "https://www.epicurious.com/recipes/food/views/sauteed-collard-greens-with-slab-bacon",
    imgURL:
      "https://assets.epicurious.com/photos/5668658600de9d2a3815fcb4/1:1/w_1280,c_limit/EP_12012015_dannymeyers_bluesmoke_Saut%C3%A9ed-Collard-Greens-with-Slab-Bacon.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "sides",
    resultId: 177,
    result: "Brussels Sprout Hash With Caramelized Shallots",
    url: "https://www.epicurious.com/recipes/food/views/brussels-sprout-hash-with-caramelized-shallots-240411",
    imgURL:
      "https://assets.epicurious.com/photos/560d9a5c7b55306961bf7895/1:1/w_1600,c_limit/240411_hires.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 61,
    result: "Kale Salad With Brussels Sprouts, Apples, and Hazelnuts",
    url: "https://www.epicurious.com/recipes/food/views/kale-salad-with-brussels-sprouts-apples-and-hazelnuts",
    imgURL:
      "https://assets.epicurious.com/photos/56324474b09b90f62d8039d5/1:1/pass/EP_10272015_Kale-Salad-with-Brussels-Sprouts,-Apples,-and-Hazelnuts.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 69,
    result: "Shaved Cauliflower Salad",
    url: "https://www.epicurious.com/recipes/food/views/shaved-cauliflower-salad",
    imgURL:
      "https://assets.epicurious.com/photos/57d1f0b2b96ba7195757bfab/1:1/pass/shaved-cauliflower-salad-BA-090816.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 70,
    result: "Hearty Greens With Kumquats",
    url: "https://www.epicurious.com/recipes/food/views/hearty-greens-with-kumquats-51123620",
    imgURL:
      "https://assets.epicurious.com/photos/54b05c89a7baf2e46eefd08b/1:1/pass/51123620_hearty-greens-kumquats_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 71,
    result: "Watercress and Persimmon Salad With Champagne Vinaigrette",
    url: "https://www.epicurious.com/recipes/food/views/watercress-and-persimmon-salad-with-champagne-vinaigrette",
    imgURL:
      "https://assets.epicurious.com/photos/5c099d5a310f346b7638d85b/1:1/pass/Gourmet-Christmas-Watercress-Persimmon-Salad-Recipe-14112018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 72,
    result: "Simplest Kale Salad",
    url: "https://www.epicurious.com/recipes/food/views/simplest-kale-salad",
    imgURL:
      "https://assets.epicurious.com/photos/5b3a7ff145bfb348d309600d/1:1/pass/KIDS-COOKING-CAMP-KALE-SALAD-27062018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 73,
    result: "Maui Kale Salad With Sweet Onion Dressing",
    url: "https://www.epicurious.com/recipes/food/views/maui-kale-salad-with-sweet-onion-dressing-sheldon-simeon-cook-real-hawaii",
    imgURL:
      "https://assets.epicurious.com/photos/60662cd9daeb433084e6b9e7/1:1/pass/Cook-Real-Hawaii_Maui-Kale-Salad-Sheldon-Simeon-040121.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 75,
    result: "Fennel and Celery Root Salad",
    url: "https://www.epicurious.com/recipes/food/views/fennel-and-celery-root-salad",
    imgURL:
      "https://assets.epicurious.com/photos/615f00552a4be4ab576b6643/1:1/pass/0317-BA-KING-02_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 76,
    result: "Frisée, Radicchio, and Fennel Salad With Mustard Vinaigrette",
    url: "https://www.epicurious.com/recipes/food/views/frisee-radicchio-and-fennel-salad-with-mustard-vinaigrette-395392",
    imgURL:
      "https://assets.epicurious.com/photos/616dd8dfd608f2bc20bfa37c/1:1/pass/FriseeRadicchioFennelSalad_RECIPE_100621_206.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 77,
    result: "Sheet-Pan Roasted Squash and Feta Salad",
    url: "https://www.epicurious.com/recipes/food/views/sheet-pan-roasted-squash-and-feta-salad",
    imgURL:
      "https://assets.epicurious.com/photos/5ba010cf235f7606710f08f8/1:1/pass/Sheet-Pan-Roasted-Squash-and-Feta-Salad-recipe-13092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 154,
    result: "Crunchy Turnip Apple and Brussels Sprout Slaw",
    url: "https://www.epicurious.com/recipes/food/views/crunchy-turnip-apple-and-brussels-sprout-slaw-51260300",
    imgURL:
      "https://assets.epicurious.com/photos/54b71ebfac90eb2c34cfba1e/1:1/pass/51260300_brussels-sprout-slaw_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 155,
    result: "Endive With Tart Apple Dressing",
    url: "https://www.epicurious.com/recipes/food/views/endive-with-tart-apple-dressing-and-blue-cheese",
    imgURL:
      "https://assets.epicurious.com/photos/59cbce6c66394706a3451ebc/1:1/pass/endive-with-tart-apple-dressing-and-blue-cheese.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 156,
    result: "Raw Butternut Squash Ribbon Salad",
    url: "https://www.epicurious.com/recipes/food/views/raw-butternut-squash-ribbon-salad-with-orange-and-chile",
    imgURL:
      "https://assets.epicurious.com/photos/5bc4da296783292d5b6f355a/1:1/pass/raw-butternut-squash-ribbon-salad-recipe-BA-101518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 157,
    result: "Iceberg Salad With Dried Oregano Dressing",
    url: "https://www.epicurious.com/recipes/food/views/iceberg-salad-with-dried-oregano-dressing-and-creamy-sheeps-milk-cheese-danielle-alvarez",
    imgURL:
      "https://assets.epicurious.com/photos/6113d9cb6996e5eaff3d1726/1:1/pass/icceberg-salad-always-add-lemon-danielle-alvarex.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 158,
    result: "Winter Slaw With Red Pears and Pumpkin Seeds",
    url: "https://www.epicurious.com/recipes/food/views/winter-slaw-with-red-pears-and-pumpkin-seeds",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7b4ab5fdf6f143612ba/1:1/pass/winter-slaw-with-red-pears-and-pumpkin-seeds-BA-111516.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 159,
    result: "Chicory Salad with Honey-Mustard Vinaigrette",
    url: "https://www.epicurious.com/recipes/food/views/chicory-escarole-radicchio-salad-with-honey-mustard-vinaigrette",
    imgURL:
      "https://assets.epicurious.com/photos/5a05db178d4fcf21753e3a12/1:1/pass/chicory-salad-with-honey-mustard-vinaigrette-recipe-BA-111017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "salads",
    resultId: 74,
    result: "skip",
    url: "",
    imgURL: "",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "cranberry",
    resultId: 90,
    result: "Fancy Cranberry Sauce",
    url: "https://www.epicurious.com/recipes/food/views/fancy-cranberry-sauce",
    imgURL:
      "https://assets.epicurious.com/photos/5dd305eb83f02e0008e65b94/1:1/pass/Fancy_cranberry_sauce_recipe_BA_111819.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "cranberry",
    resultId: 91,
    result: "Cranberry Sauce With Orange and Cinnamon",
    url: "https://www.epicurious.com/recipes/food/views/cranberry-sauce-with-orange-and-cinnamon",
    imgURL:
      "https://assets.epicurious.com/photos/5be07fbee4cc802d1e276d35/1:1/pass/cranberry-sauce-with-orange-and-cinnamon-recipe-BA-110518.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "cranberry",
    resultId: 92,
    result: "Cranberry-Cherry Compote",
    url: "https://www.epicurious.com/recipes/food/views/cranberry-cherry-compote",
    imgURL:
      "https://assets.epicurious.com/photos/5dbc3b824d23c000097d7f10/1:1/pass/Cranberry_RECIPE_102419_4978.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "cranberry",
    resultId: 93,
    result: "Cranberry Relish With Pineapple and Orange",
    url: "https://www.epicurious.com/recipes/food/views/cranberry-relish-with-pineapple-and-orange",
    imgURL:
      "https://assets.epicurious.com/photos/616482209899407edd335edf/1:1/pass/CranberryPineappleRelish_RECIPE_00621_041.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "cranberry",
    resultId: 160,
    result: "Basic Cranberry Sauce",
    url: "https://www.epicurious.com/recipes/food/views/basic-cranberry-sauce-236532",
    imgURL:
      "https://assets.epicurious.com/photos/5fa1718f5e221e8ae0a2918e/1:1/pass/GRAND-MARNIER-CRANBERRY-SAUCE-RECIPE-07092017_V1_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 94,
    result: "Caramelized Honey Pumpkin Pie",
    url: "https://www.epicurious.com/recipes/food/views/caramelized-honey-pumpkin-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5fb8028324d8f726e213385d/1:1/pass/PUMPKIN_PIE_6X4_VOG_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 95,
    result: "Butternut Pumpkin Pie",
    url: "https://www.epicurious.com/recipes/food/views/butternut-pumpkin-pie",
    imgURL:
      "https://assets.epicurious.com/photos/59f1f75839cfd2389da0f54a/1:1/pass/butternut-pumpkin-squash-pie-stella-parks-recipe-102617.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 96,
    result: "Vegan Pumpkin Pie",
    url: "https://www.epicurious.com/recipes/food/views/vegan-pumpkin-pie-56390152",
    imgURL:
      "https://assets.epicurious.com/photos/615763516ffd8703e712dd5a/1:1/pass/VeganPumpkinPie_RECIPE_093021_21444.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 97,
    result: "Sweet Potato Pie",
    url: "https://www.epicurious.com/recipes/food/views/sweet-potato-pie-jubilee",
    imgURL:
      "https://assets.epicurious.com/photos/5fa0557779da961287dfa90e/1:1/pass/SweetPotatoPie_HERO_v2_102920_4095.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 98,
    result: "Pecan-Rye Pumpkin Pie",
    url: "https://www.epicurious.com/recipes/food/views/pecan-rye-pumpkin-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5dd30a68d482f10008d4fb29/1:1/pass/pecan_rye_pumpkin_pie_recipe_BA_111819.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 99,
    result: "Fall Fruit Galette",
    url: "https://www.epicurious.com/recipes/food/views/fall-fruit-apple-pear-galette",
    imgURL:
      "https://assets.epicurious.com/photos/5d780d2719be0f00087952dc/1:1/pass/fall-fruit-galette-recipe-BA-091019.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 100,
    result: "Our Favorite Apple Pie",
    url: "https://www.epicurious.com/recipes/food/views/our-favorite-apple-pie-51248690",
    imgURL:
      "https://assets.epicurious.com/photos/59bc150e74febd49ca741558/1:1/pass/CINNAMON-CRUMBLE-APPLE-PIE-RECIPE-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 101,
    result: "Pecan-Cranberry Galette",
    url: "https://www.epicurious.com/recipes/food/views/pecan-cranberry-galette",
    imgURL:
      "https://assets.epicurious.com/photos/5bce4f35beb1821bea8db9cb/1:1/pass/Thanksgiving-2-4-Pecan-Cranberry-Galette-recipe-09102018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 102,
    result: "Pecan-Orange Baklava Pie",
    url: "https://www.epicurious.com/recipes/food/views/pecan-orange-baklava-pie",
    imgURL:
      "https://assets.epicurious.com/photos/59d28ea212a8092c2d339e32/1:1/pass/Pecan-Baklava-recipe-28092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 104,
    result: "Banana Cream Pie",
    url: "https://www.epicurious.com/recipes/food/views/banana-cream-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5dd3082002f76c00099dfb9b/1:1/pass/Banana_cream_pie_recipe_BA_111819.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 105,
    result: "Chocolate Pudding Pie",
    url: "https://www.epicurious.com/recipes/food/views/chocolate-pudding-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5ddbef653801e50009d8713e/1:1/pass/Chocolate_pudding_pie_recipe_BA_112519.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 106,
    result: "Nutella Pie",
    url: "https://www.epicurious.com/recipes/food/views/nutella-pie-51229210",
    imgURL:
      "https://assets.epicurious.com/photos/54ac95e819925f464b3ac37e/1:1/pass/51229210_nutella-pie_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 107,
    result: "Black-Bottom Hazelnut Pie",
    url: "https://www.epicurious.com/recipes/food/views/black-bottom-hazelnut-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5dc1eb005eb0dd0009b00b93/1:1/pass/HazelnutPie_RECIPE_103019_5556.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 108,
    result: "Coconut Rice Pudding Pie",
    url: "https://www.epicurious.com/recipes/food/views/rice-pudding-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5cf6982a5a70e82761c4377e/1:1/pass/Meme's_RicePuddingPie_Whole_053019_Inset_204.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 109,
    result: "Sweet Potato–Miso Pie with Chocolate-Sesame Crust",
    url: "https://www.epicurious.com/recipes/food/views/sweet-potato-miso-pie-with-chocolate-sesame-crust",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7b331bd0b471cece710/1:1/pass/sweet-potato-miso-pie-BA-111516.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 110,
    result: "Apple and Calvados Tart",
    url: "https://www.epicurious.com/recipes/food/views/apple-and-calvados-tart-107610",
    imgURL:
      "https://assets.epicurious.com/photos/5cad30144507ff1282e77141/1:1/pass/Apple-and-Calvados-Tart-recipe-03042019.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 111,
    result: "Vegan Pecan Pie",
    url: "https://www.epicurious.com/recipes/food/views/vegan-pecan-pie-petees-pie-for-everyone",
    imgURL:
      "https://assets.epicurious.com/photos/616dcb05dca285ba0712ac3d/1:1/pass/VeganPecanPie_RECIPE_093021_21511.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 112,
    result: "Coconut Cream Pie With Macaroon Press-in Crust",
    url: "https://www.epicurious.com/recipes/food/views/coconut-cream-pie-with-macaroon-press-in-crust-56389556",
    imgURL:
      "https://assets.epicurious.com/photos/5f7cd87d9148dbc90fa1d278/1:1/pass/0515-BA-BIND-01_V2_e.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 161,
    result: "Old-Fashioned Pecan Pie",
    url: "https://www.epicurious.com/recipes/food/views/old-fashioned-pecan-pie-356072",
    imgURL:
      "https://assets.epicurious.com/photos/59bc16e71782591a4bc6659a/1:1/pass/OLD-FASHIONED-PECAN-PIE-07092017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 162,
    result: "Layered Apple Pie With Phyllo Crust",
    url: "https://www.epicurious.com/recipes/food/views/layered-apple-pie-with-phyllo-crust-56390160",
    imgURL:
      "https://assets.epicurious.com/photos/561d75b153de6d0d5cde359f/1:1/pass/EP_09292015_thanksgivingpie_apple.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 163,
    result: "3-Ingredient Caramel Apple Tart",
    url: "https://www.epicurious.com/recipes/food/views/3-ingredient-caramel-apple-tart",
    imgURL:
      "https://assets.epicurious.com/photos/57ea9993983afd6d50ac3dd3/1:1/pass/3-Ingredient-Caramel-Apple-Tart-recipe-01092016.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "pie",
    resultId: 164,
    result: "Pumpkin Icebox Pie With Snickerdoodle Crust",
    url: "https://www.epicurious.com/recipes/food/views/pumpkin-icebox-pie-with-snickerdoodle-crust-56390159",
    imgURL:
      "https://assets.epicurious.com/photos/5db86aab821f320009c8c97f/1:1/pass/Snickerdoodle_RECIPE_102419_4742.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 113,
    result: "Pear Tart With Dulce de Leche Drizzle",
    url: "https://www.epicurious.com/recipes/food/views/pear-tart-dulce-de-leche-drizzle-judy-kim",
    imgURL:
      "https://assets.epicurious.com/photos/5fa986c759365f22c403a32d/1:1/pass/JudyKimPearTart_HER0_102920_4326.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 114,
    result: "Pear and Hazelnut Frangipane Tart",
    url: "https://www.epicurious.com/recipes/food/views/pear-tart-dulce-de-leche-drizzle-judy-kim",
    imgURL:
      "https://assets.epicurious.com/photos/5fa986c759365f22c403a32d/1:1/pass/JudyKimPearTart_HER0_102920_4326.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 115,
    result: "Cranberry Chess Pie",
    url: "https://www.epicurious.com/recipes/food/views/cranberry-chess-pie",
    imgURL:
      "https://assets.epicurious.com/photos/5fa04c6f998f5b502137b128/1:1/pass/CranberryLemonChessPie_RECIPE_v1_102920_4120.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 116,
    result: "Cranberry-Lime Pie",
    url: "https://www.epicurious.com/recipes/food/views/cranberry-lime-pie",
    imgURL:
      "https://assets.epicurious.com/photos/582cc7aa31bd0b471cece702/1:1/pass/cranberry-lime-pie-BA-111616.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 117,
    result: "Pumpkin and Cookie-Butter Sheet Cake With Toasted Meringue",
    url: "https://www.epicurious.com/recipes/food/views/pumpkin-and-cookie-butter-sheet-cake-with-toasted-meringue",
    imgURL:
      "https://assets.epicurious.com/photos/5b981abb8127422e2d2f45cd/1:1/pass/Pumpkin-and-Cookie-Butter-Sheet-Cake-With-Toasted-Meringue-recipe-05092018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 118,
    result: "Lemon-Pistachio Loaf",
    url: "https://www.epicurious.com/recipes/food/views/vegan-lemon-pistachio-loaf",
    imgURL:
      "https://assets.epicurious.com/photos/5da0c42f7e9a8e0008826fbb/1:1/pass/Lemon-Pistachio-Loaf-recipe-BA-101119.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 119,
    result: "Berry Cream Cheese Cake",
    url: "https://www.epicurious.com/recipes/food/views/berry-cream-cheese-cake-yossi-arefi",
    imgURL:
      "https://assets.epicurious.com/photos/5f774f31cb1e2d09879fb70c/1:1/pass/CranberryCreamcheeseCake_RECIPE091620_11970_V1_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 120,
    result: "Three Cities of Spain Cheesecake",
    url: "https://www.epicurious.com/recipes/food/views/three-cities-of-spain-cheesecake-102595",
    imgURL:
      "https://assets.epicurious.com/photos/5b2941f3633abc5aa71cc8dd/1:1/pass/Why-This-Is-the-Best-Cheesecake-Ever-14062018.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 121,
    result: "Peanut Butter Coconut Cream Cookie Sandwiches",
    url: "https://www.epicurious.com/recipes/food/views/peanut-butter-coconut-cream-cookie-sandwiches",
    imgURL:
      "https://assets.epicurious.com/photos/60d9eb089e040b1d0fd16a35/1:1/pass/PBCoconutCreamCookies_RECIPE_062321_18569.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 122,
    result: "Chocolate–Almond Praline Cookies",
    url: "https://www.epicurious.com/recipes/food/views/chocolate-almond-praline-cookies",
    imgURL:
      "https://assets.epicurious.com/photos/5a05db11f819553e017bd98b/1:1/pass/chocolate-almond-praline-cookies-recipe-BA-111017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 123,
    result: "Apple Pie Cookies",
    url: "https://www.epicurious.com/recipes/food/views/apple-pie-cookies",
    imgURL:
      "https://assets.epicurious.com/photos/59e7ae02d1492775e194acfb/1:1/pass/Apple-Pie-Cookies-11102017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 124,
    result: "Retro Strawberries-and-Cream Pretzel Tart",
    url: "https://www.epicurious.com/recipes/food/views/retro-strawberries-and-cream-pretzel-tart-51194410",
    imgURL:
      "https://assets.epicurious.com/photos/59e8fc7b4a8c7d5b9d946bf9/1:1/pass/Strawberry-Pretzel-Salad-recipe-17102017.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 125,
    result: "Sweet Potato Basque Cheesecake",
    url: "https://www.epicurious.com/recipes/food/views/basque-style-sweet-potato-cheesecake",
    imgURL:
      "https://assets.epicurious.com/photos/6143632f0a840e99a4b7dc5d/1:1/pass/BasqueCheesecake_RECIPE_091321_20828.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 126,
    result: "Bibingkang Cassava",
    url: "https://www.epicurious.com/recipes/food/views/cassava-cake-bibingkang-cassava",
    imgURL:
      "https://assets.epicurious.com/photos/5f2323f527f5029eb16c5fab/1:1/pass/CassavaCake_HERO_072220_9891_V2_final.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 127,
    result: "Baked Chocolate Tofu Cheesecake",
    url: "https://www.epicurious.com/recipes/food/views/baked-chocolate-tofu-vegan-cheesecake-donna-hay",
    imgURL:
      "https://assets.epicurious.com/photos/5faec7a8ce61e49fc0f61956/1:1/pass/Baked-Chocolate-Tofu-Cheesecake-HC-111320.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 166,
    result: "Almond-Crust Raspberry Cheesecake",
    url: "https://www.epicurious.com/recipes/food/views/almond-crust-raspberry-cheesecake-51235380",
    imgURL:
      "https://assets.epicurious.com/photos/555a15a0100d9bda6d81eefa/1:1/pass/51235380_almond-crust-raspberry-cheesecake_1x1.jpg",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
  {
    category: "dessert",
    resultId: 169,
    result: "skip",
    url: "",
    imgURL: "",
    url2: null,
    imgURL2: null,
    url3: null,
    imgURL3: null,
    noOfDishes: null,
  },
]
